"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownButton = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = require("../Button/Button");
var _index = require("../Icon/index");
/**
 * A button variant to be used with `DropdownPopper`.
 *
 * @extends Button
 * @related [`DropdownIcon`, `DropdownPopper`]
 * @since 7.28.0
 */
var DropdownButton = /*#__PURE__*/(0, _styledComponents.default)(_Button.Button).withConfig({
  displayName: "DropdownButton",
  componentId: "c11n-8-107-0__sc-1nhw8sf-0"
})([""]);
exports.DropdownButton = DropdownButton;
DropdownButton.displayName = 'DropdownButton';
DropdownButton.propTypes = {
  /**
   * The button content.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * @ignore
   */
  icon: _propTypes.default.node,
  /**
   * @ignore
   */
  iconPosition: _propTypes.default.string,
  /**
   * @ignore
   */
  iconSize: _propTypes.default.string
};
DropdownButton.defaultProps = {
  icon: /*#__PURE__*/_react.default.createElement(_index.IconChevronDown, null),
  iconPosition: 'end',
  iconSize: 'xs'
};

/** @component */